import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { SENTRY_DSN } from '../config/index'

let environment = 'dev'
switch (window.location.hostname) {
  case 'dss.test.xiaopeng.local':
    environment = 'test'
    break
  case 'dss.deploy-test.xiaopeng.com':
    environment = 'preview'
    break
  case 'dss.xiaopeng.com':
    environment = 'production'
    break
  default:
    break
}
const version = 'xp-digital-smart-service@' + require('../../package.json').version

const SentryInit = (devNeed = false) => {
  if (!devNeed && environment === 'dev') {
    return
  }
  
  Sentry.init({
    dsn: SENTRY_DSN,
    environment,
    release: version,
    debug: environment === 'dev',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.5,
  })
}

export default SentryInit
